import React, { useState, useEffect, useCallback } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import logo_dark from "../assets/img/logo.png";
import { Icon } from "@iconify/react";

// 🔹 Moved pages array outside the component
const pages = [
  {
    id: "Dashboard",
    title: "Dashboard",
    link: "/dashboard",
    icon: "mdi:view-grid-outline",
  },
  {
    id: "Users",
    title: "Users",
    link: "/users",
    icon: "lucide:users",
  },
  {
    id: "Posts",
    title: "Posts",
    link: "/posts",
    icon: "material-symbols-light:post-add-rounded",
  },
  {
    id: "Ads",
    title: "Ads",
    link: "/ads",
    icon: "material-symbols-light:ads-click-rounded",
  },
  {
    id: "Interests",
    title: "Interests",
    link: "/interests",
    icon: "material-symbols:interests",
  },
  {
    id: "Contacts",
    title: "Contacts",
    link: "/contacts",
    icon: "material-symbols:contacts",
  },
  {
    id: "Flags Reports",
    title: "Flags Reports",
    link: "/flags-reports",
    icon: "material-symbols:flag",
  },
  {
    id: "Pages",
    title: "Pages",
    link: "/pages",
    icon: "bx:file",
  },
  {
    id: "ProfileSettings",
    title: "Profile Settings",
    link: "/profile-settings",
    icon: "solar:settings-outline",
  },
  {
    id: "Logout",
    title: "Logout",
    link: "/",
    icon: "material-symbols:logout",
  },
];

const Sidebar = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [openSubmenu, setOpenSubmenu] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setSidebarOpen(width >= 768);
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Trigger on mount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  useEffect(() => {
    document.body.classList.toggle("no-scroll", sidebarOpen);
  }, [sidebarOpen]);

  const handleNavLinkClick = () => {
    setSidebarOpen(false);
    setOpenSubmenu(null);
  };

  const handleSubmenuClick = (id) => {
    setOpenSubmenu(openSubmenu === id ? null : id);
  };

  const isSubmenuItemActive = useCallback(
    (submenu) => {
      return submenu.some((sub) => location.pathname.startsWith(sub.link));
    },
    [location.pathname]
  );

  useEffect(() => {
    const currentPage = pages.find(
      (page) => page.submenu && isSubmenuItemActive(page.submenu)
    );
    if (currentPage && currentPage.submenu) {
      setOpenSubmenu(currentPage.id);
    } else {
      setOpenSubmenu(null);
    }
  }, [location.pathname, isSubmenuItemActive]);

  return (
    <>
      <button
        onClick={toggleSidebar}
        className="btnopen"
        style={{ display: "none" }}
      >
        <Icon icon="solar:hamburger-menu-broken" />
      </button>
      <div
        className={
          sidebarOpen ? "sidebar sidebar-open" : "sidebar sidebar-closed"
        }
      >
        <div className="sidebarlogo_div">
          <Link to="/dashboard">
            <img src={logo_dark} alt="Logo" />
          </Link>
        </div>
        <div className="sidebarouter">
          {pages.map((page) => (
            <div key={page.id} className="navitem-container">
              <NavLink
                to={page.link}
                className={`navitem ${
                  openSubmenu === page.id ||
                  (page.submenu && isSubmenuItemActive(page.submenu))
                    ? "active"
                    : ""
                }`}
                onClick={
                  page.submenu
                    ? (e) => {
                        e.preventDefault();
                        handleSubmenuClick(page.id);
                      }
                    : handleNavLinkClick
                }
              >
                <div className="flex-grow-1">
                  <Icon icon={page.icon} />
                  {page.title}
                </div>
                {page.submenu && (
                  <Icon
                    icon={
                      openSubmenu === page.id
                        ? "mdi:chevron-up"
                        : "mdi:chevron-down"
                    }
                    className={`submenu-icon me-0 ${
                      openSubmenu === page.id ? "open" : ""
                    }`}
                  />
                )}
              </NavLink>
              {page.submenu && openSubmenu === page.id && (
                <div className="submenu">
                  {page.submenu.map((sub) => (
                    <NavLink
                      key={sub.id}
                      to={sub.link}
                      className={`submenu-item ${
                        location.pathname.startsWith(sub.link) ? "active" : ""
                      }`}
                      onClick={handleNavLinkClick}
                    >
                      {sub.title}
                    </NavLink>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Sidebar;
